import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daysToDhM'  
})
export class DayHourMinutePipe implements PipeTransform {
  transform(value: number): string {
    if (value == null) return '';

    const totalMinutes = Math.round(value * 24 * 60); // Convert days to minutes
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;

    return `${days}d ${hours}h ${minutes}m`;
  }
}
